import React from 'react';
import { CategoryLink } from './CategoryLink';

export const CategoriesNav = ({ isLoading, error, data }) => {
    const categories = !isLoading && !error ? data.records : [];

    return categories.map((category) => <CategoryLink key={category.id} {...category} />);
};
